import { render, staticRenderFns } from "./RoomNotif.vue?vue&type=template&id=ac27e928&scoped=true&"
import script from "./RoomNotif.vue?vue&type=script&lang=ts&"
export * from "./RoomNotif.vue?vue&type=script&lang=ts&"
import style0 from "./RoomNotif.vue?vue&type=style&index=0&id=ac27e928&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac27e928",
  null
  
)

export default component.exports